import React from "react";
import "./index.css";
import ReactDOM from "react-dom";
import { App } from "./App";
import { DeployTypes } from "./services/ServiceWrapper";

const ELEMENT_ID = "freeplay-widget-container";

const ShowFreeplayWidget = (
    elementForRender: HTMLElement,
    tenantSlug: string,
    deployType: DeployTypes | undefined,
    alternateTheme: boolean,
    eventId?: string | undefined,
) => {
    ReactDOM.render(
        <App tenantSlug={tenantSlug} eventId={eventId} deployType={deployType} alternateTheme={alternateTheme} />,
        elementForRender,
    );
};

// Methods to get information from the script embed
// this would be for noting where it's embedded
// or determining the landing point

// Need better way to handle both single and double tag embeds.
// function createDivAndEmbedWidget() {
//     const newDiv = document.createElement("div");
//     const scriptTag = document.getElementById("freeplay-widget-script");
//     scriptTag?.parentNode?.insertBefore(newDiv, scriptTag);
//     const deployType = scriptTag?.getAttribute("data-deploy-type");

//     console.log("potatoe salad", deployType);
//     ShowFreeplayWidget(newDiv, deployType ?? "");
// }

function setDOMListener() {
    document.addEventListener("DOMContentLoaded", () => {
        // if there's a widget, grab it and attach to it.
        const evtWidgetDiv = document.getElementById(ELEMENT_ID);
        if (evtWidgetDiv !== null) {
            // find out other attrs
            const deployType = evtWidgetDiv?.getAttribute("data-deploy-type") as DeployTypes | undefined;
            const tenantSlug = evtWidgetDiv?.getAttribute("data-tenant-slug") as string | undefined;
            const alternateTheme = evtWidgetDiv?.getAttribute("data-alt-theme") as string | undefined;
            const eventId = evtWidgetDiv?.getAttribute("data-event-id") as string | undefined;
            ShowFreeplayWidget(
                evtWidgetDiv,
                tenantSlug ?? "",
                deployType ?? "embed",
                alternateTheme === "true",
                eventId ?? undefined,
            );
        } else {
            console.error(
                `There was an error in loading the betting widget. Please check to make sure proper div is setup.`,
            );
        }
    });
}

function main() {
    const widgetDiv = document.getElementById(ELEMENT_ID);

    if (widgetDiv === null) {
        setDOMListener();
    } else {
        const deployType = widgetDiv?.getAttribute("data-deploy-type") as DeployTypes | undefined;
        const tenantSlug = widgetDiv?.getAttribute("data-tenant-slug") as string | undefined;
        const alternateTheme = widgetDiv?.getAttribute("data-alt-theme") as string | undefined;
        const eventId = widgetDiv?.getAttribute("data-event-id") as string | undefined;
        ShowFreeplayWidget(
            widgetDiv,
            tenantSlug ?? "",
            deployType ?? "standalone",
            alternateTheme === "true",
            eventId ?? undefined,
        );
    }
}

main();
